import { jsx as o } from "react/jsx-runtime";
import m from "../InputContainer/index.js";
import f from "../RawInput/index.js";
import { extractInputContainerProps as c } from "../../utils/inputs.js";
function C(p) {
  const {
    disabled: t,
    inputClassName: e,
    readOnly: r,
    required: n,
    type: a = "text",
    ...i
  } = p, [s, u] = c(
    i
  );
  return /* @__PURE__ */ o(
    m,
    {
      ...s,
      disabled: t,
      readOnly: r,
      required: n,
      input: /* @__PURE__ */ o(
        f,
        {
          ...u,
          className: e,
          disabled: t,
          readOnly: r,
          required: n,
          type: a
        }
      )
    }
  );
}
export {
  C as default
};
